import { render } from "./AppAbout.vue?vue&type=template&id=3444da6a&scoped=true"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"

import "./AppAbout.vue?vue&type=style&index=0&id=3444da6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444da6a"]])

export default __exports__